import { render, staticRenderFns } from "./ImageMagnifier.vue?vue&type=template&id=671c4df0&scoped=true"
import script from "./ImageMagnifier.vue?vue&type=script&lang=js"
export * from "./ImageMagnifier.vue?vue&type=script&lang=js"
import style0 from "./ImageMagnifier.vue?vue&type=style&index=0&id=671c4df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c4df0",
  null
  
)

export default component.exports